<template>
    <div class="novice-guide">
        <img src="../../.././assets/images/normal/novice_1.png" alt="" class="novicePic" />
        <img src="../../.././assets/images/normal/novice_2.png" alt="" class="novicePic" />
        <img src="../../.././assets/images/normal/novice_3.png" alt="" class="novicePic" />
    </div>
</template>
<script>
export default {
    name: "noviceGuide",
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
</script>

<style lang="less">
.novice-guide {
    display: block;
    width: 100%;
    background: url(../../.././assets/images/normal/novice_bg.jpg) no-repeat;
    background-size: 100% 100%;
    padding-top: 114px;
    .novicePic {
        display: block;
        width: 100%;
        margin: -40px auto 0;
    }
    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
        .novice-guide {
            padding-top: 128px !important;
        }
        body {
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
        }
    }
}
</style>
